import { render, staticRenderFns } from "./dialogPayerInfo.vue?vue&type=template&id=5861ab5d&scoped=true&"
import script from "./dialogPayerInfo.vue?vue&type=script&lang=js&"
export * from "./dialogPayerInfo.vue?vue&type=script&lang=js&"
import style0 from "./dialogPayerInfo.vue?vue&type=style&index=0&id=5861ab5d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5861ab5d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dgq/mei_bao_pro/insuranceagent-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5861ab5d')) {
      api.createRecord('5861ab5d', component.options)
    } else {
      api.reload('5861ab5d', component.options)
    }
    module.hot.accept("./dialogPayerInfo.vue?vue&type=template&id=5861ab5d&scoped=true&", function () {
      api.rerender('5861ab5d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "meibao-insure/src/components/dialog/dialogPayerInfo.vue"
export default component.exports